import { mount } from 'svelte'
import DraftsList from '@/components/drafts-list/DraftsList.svelte'

function mountDraftsListApp() {
  const el = document.getElementById('drafts-list-app') as HTMLElement | null
  if (!el) return
  // Idempotent — don't double-mount if the AJAX flow re-fires after we already
  // mounted (the element instance is the same; refresh swaps it out).
  if ((el as any).__svelteMounted) return
  ;(el as any).__svelteMounted = true

  mount(DraftsList, {
    target: el,
    props: {
      draftsUrl:    el.dataset.draftsUrl ?? '',
      initialCount: parseInt(el.dataset.draftsCount ?? '0', 10),
    },
  })
}

document.addEventListener('DOMContentLoaded', mountDraftsListApp)

// Exposed so the messages/index.js.erb AJAX response can re-run the mount
// after replacing .msg-stream with the drafts mount partial.
;(window as any).mountDraftsListApp = mountDraftsListApp
